import { render, staticRenderFns } from "./GoodReceiptDisplayView.vue?vue&type=template&id=08d15cc0"
import script from "./GoodReceiptDisplayView.vue?vue&type=script&lang=js"
export * from "./GoodReceiptDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports